import { For, onCleanup } from "solid-js"
import "@/datox/v2/tokens.css"
import "@/datox/v2/home.css"
import "@/datox/v2/reports.css"

const TILES = 8

// The reports grid while it loads: pale tiles in the list's own shape, so the page doesn't jump when they arrive.
export function ReportsSkeleton(props: { label: string }) {
  return (
    <div class="dx-tiles dx-skel-tiles" role="status" aria-live="polite" aria-label={props.label}>
      <For each={Array.from({ length: TILES })}>
        {() => (
          <div class="dx-tile dx-skel-tile" aria-hidden="true">
            <span class="dx-skel-preview"><i /></span>
            <span class="dx-skel-foot"><i /><i /><i /></span>
          </div>
        )}
      </For>
    </div>
  )
}

// Silent sign-in (P21): the app's first screen is /reports, so the wait shows its outline (sidebar, filters, the grid)
// instead of a full-screen "Preparing sign in…", and the tab already says Lesha Bank. The status text stays for screen
// readers. The sidebar's width follows what the shell will show: expanded on a wide window unless it was collapsed.
export function LeshaBootSkeleton(props: { label: string; title: string }) {
  const previous = document.title
  document.title = props.title
  onCleanup(() => {
    if (document.title === props.title) document.title = previous
  })
  const collapsed = () => {
    try {
      return Object.keys(localStorage).some((key) => key.startsWith("dx-v2-sidebar:") && localStorage.getItem(key) === "collapsed")
    } catch {
      return false
    }
  }
  const expanded = (typeof window.matchMedia !== "function" || window.matchMedia("(min-width: 1100px)").matches) && !collapsed()
  return (
    <div class="dx-v2-shell dx-v2 dx-skel-boot">
      <nav class="dx-v2-rail" data-expanded={expanded || undefined} aria-hidden="true">
        <img class="dx-skel-mark" src={expanded ? "/lesha-bank-logo.png" : "/lesha-bank-mark.png"} alt="" />
        <For each={Array.from({ length: 4 })}>{() => <span class="dx-skel-row"><i /></span>}</For>
      </nav>
      <section class="dx-home dx-rl">
        <aside class="dx-filters" aria-hidden="true">
          <span class="dx-skel-line" style={{ width: "40%" }} />
          <span class="dx-skel-search" />
          <For each={Array.from({ length: 9 })}>{(_, index) => <span class="dx-skel-line" style={{ width: `${55 + ((index() * 17) % 35)}%` }} />}</For>
        </aside>
        <div class="dx-home-canvas">
          <div class="dx-home-toolbar" aria-hidden="true"><span class="dx-skel-line" style={{ width: "120px" }} /></div>
          <div class="dx-home-body"><ReportsSkeleton label={props.label} /></div>
        </div>
      </section>
    </div>
  )
}
